<div [ngSwitch]="modalType">
  <div *ngSwitchCase="'add-edit-survey'">
    <app-add-survey
      [title_tag]="title"
      [formType]="formType"
      [form_data]="formData"
      [surveys_data]="surveyData"
    ></app-add-survey>
  </div>
  <div *ngSwitchCase="'add-edit-cognitive'">
    <app-add-cognitive [title_tag]="title" [formType]="formType" [form_data]="formData"></app-add-cognitive>
  </div>
  <div *ngSwitchCase="'add-edit-activity'">
    <app-add-activity [title_tag]="title" [formType]="formType" [form_data]="formData"></app-add-activity>
  </div>
  <div *ngSwitchCase="'add-edit-wellbeing'">
    <app-add-well-being [title_tag]="title" [formType]="formType" [form_data]="formData"></app-add-well-being>
  </div>
  <div *ngSwitchCase="'add-notification'">
    <app-add-notification [title_tag]="title" [formType]="formType"></app-add-notification>
  </div>
  <div *ngSwitchCase="'add-edit-question'">
    <app-add-question
      [title_tag]="title"
      [formType]="formType"
      [form_data]="formData"
      [uuid_data]="uuidData"
      [data_table]="dataTable"
      [show_answers]="showAnswers"
    ></app-add-question>
  </div>
  <div *ngSwitchCase="'add-edit-email-template'">
    <app-add-edit-email-template
      [title_tag]="title"
      [formType]="formType"
      [form_data]="formData"
    ></app-add-edit-email-template>
  </div>
  <div *ngSwitchCase="'add-edit-access'">
    <app-add-access [title_tag]="title" [formType]="formType" [form_data]="formData"></app-add-access>
  </div>
  <div *ngSwitchCase="'add-edit-schedule'">
    <app-add-schedule [title_tag]="title" [formType]="formType" [form_data]="formData"></app-add-schedule>
  </div>
</div>
